import amplitude from 'amplitude-js'


const API_KEY = 'c704d185e5372c19c77f108167e0435f'
const isEnabled = !!API_KEY

let instance

if (isEnabled) {
  instance = amplitude.getInstance()
  
  instance.init(API_KEY, null, {
    apiEndpoint: 'playcode.io/ampl'
  })
}

export function track(name, properties = {}) {
  if (!isEnabled) return
  
  return instance.logEvent(name, properties)
}

export function setUserId(id) {
  if (!isEnabled) return
  
  const userId = Number.isInteger(id) ? `userid-${id}` : id
  return instance.setUserId(userId)
}

export function identify(data) {
  if (!isEnabled) return
  
  const _identify = new instance.Identify()
  
  for (const [field, value] of Object.entries(data)) {
    _identify.set(field, value)
  }
  
  return instance.identify(_identify)
}

export function groupIdentify(groupType, groupName, _identify) {
  if (!isEnabled) return
  
  return instance.groupIdentify(groupType, groupName, _identify)
}

export function logout() {
  if (!isEnabled) return
  
  setUserId(null)
  instance.regenerateDeviceId()
}

export default {
  track,
  setUserId,
  identify,
  groupIdentify,
  logout,
  instance
}

